import { render, staticRenderFns } from "./CancelsReasons.vue?vue&type=template&id=073d017c&"
import script from "./CancelsReasons.vue?vue&type=script&lang=js&"
export * from "./CancelsReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports